import Modal from '../../../../Modal'
import Button from '../../../../Button'
import { useTourContext } from '../../../../../context/TourContext'

const CloseTutorialModal = () => {
  const { isCloseModalOpened, onCloseTutorial, handleCloseModal } =
    useTourContext()
  return (
    <Modal
      closeOnDocumentClick={false}
      isOpen={isCloseModalOpened}
      closeModal={handleCloseModal}
      width={'350px'}
    >
      <div className="text-over-primary-background text-md">
        Sigur vrei să închizi tutorialul?
      </div>
      <div className="flex mt-10 justify-between">
        <Button onClick={handleCloseModal} className="bg-btn-primary min-w-20">
          Nu
        </Button>
        <Button
          id="close-tutorial-btn"
          onClick={onCloseTutorial}
          className="bg-btn-primary min-w-20"
        >
          Da
        </Button>
      </div>
    </Modal>
  )
}

export default CloseTutorialModal
